module.exports = __webpack_public_path__ + "static/favicon-3c59cf2b090538e8d5059f31c320cced.ico";